module.exports = __webpack_public_path__ + "img/frs2.c54841e4.jpg";